import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TabPane } from 'reactstrap';
import ParadigmaAsyncSeeker from "../../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import ParadigmaLabeledInput from "../../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import api from "../../../../../api";

import '../styles.css';

class TabRelacionados extends Component {
     constructor(props) {
          super(props);
     }

     render() {
          const {vars, getError, onChangeField, data} = this.props;
          return (
               <TabPane tabId="4" className="modalArticuloTabContainer modalArticuloTabContainer-Relacionados">
               <ParadigmaLabeledInput
                   md={[2, 10]}
                   label={"Artículos"}
                   inputComponent={
                       <ParadigmaAsyncSeeker
                           multiselect={true}
                           disabled={vars.disabled}
                           onChange={(value) => onChangeField("related_ids", value.map(item=>item.id))}
                           displayField="Titulo"
                           url={api.gestion.articulos.articulos + "?fields=id,Titulo&paginationEnabled=False&sort=Titulo"}
                           value={data.related_ids}
                       />
                   }
               />
               </TabPane>
          );
     }
}

export default TabRelacionados;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Articulos/ModalArticulo/TabRelacionados.js